import React from 'react';
import { Heart, ArrowRight, PawPrint } from 'lucide-react';
import { Link } from 'react-router-dom';

export function Hero() {
  const [currentSlide, setCurrentSlide] = React.useState(1);

  const slides = [
    {
      image: "/images/animals/fundacja-znajdki-img-5927.webp",
      title: "Fundacja Znajdki",
      class: "scale-x-[-1]",
      alt: "Zdjęcie ze schroniska Fundacja Znajdki"
    },
    {
      image: "/images/animals/fundacja-znajdki-img-6126.webp",
      title: "Zostań domem",
      subtitle: "tymczasowym",
      class: "scale-x-[-1]",
      alt: "Zostań domem tymczasowym - Fundacja Znajdki"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide(prev => prev === slides.length ? 1 : prev + 1);
  };

  //

  React.useEffect(() => {
    const timer = setInterval(nextSlide, 8000);
    return () => clearInterval(timer);
  }, []);

  const currentSlideData = slides[currentSlide - 1];

  return (
    <header className="relative min-h-[80vh]">
      <div className="absolute inset-0">
        <img
          src={currentSlideData.image}
          alt={currentSlideData.alt}
          srcSet={`
            /images/animals/fundacja-znajdki-img-${currentSlide === 1 ? '5927' : '6126'}.webp 1x,
            /images/animals/fundacja-znajdki-img-${currentSlide === 1 ? '5927' : '6126'}.webp 2x
          `}
          sizes="100vw"
          className={`w-full h-full object-cover transition-all duration-1000 ease-in-out ${currentSlideData.class} object-[left_top]`}
          loading="eager"
          decoding="async"
          fetchPriority="high"
          width="1920"
          height="1080"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent transition-opacity duration-1000" />
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 min-h-[80vh] flex items-center">
        <div className="max-w-2xl pl-8 md:pl-12 pr-8 md:pr-12">
          <span className="hidden sm:inline-flex items-center gap-2 bg-accessible-red-600/90 text-white px-4 py-2 rounded-full text-sm font-medium mb-6">
            <PawPrint className="w-4 h-4" aria-hidden="true" />
            <span className="text-white font-medium">Znajdź swojego przyjaciela</span>
          </span>
          
          <h1 className="hero-text mb-6 md:mb-8 transition-all duration-1000 ease-in-out transform">
            {currentSlideData.title} <br />
            <span className="text-accessible-red-600">{currentSlideData.subtitle}</span>
          </h1>
          
          <p className="hero-subtitle mb-10 transition-all duration-1000 ease-in-out transform max-w-xl hidden sm:block">
            Każde zwierzę zasługuje na miłość i dom. Dołącz do nas w misji ratowania i znajdowania nowych domów dla porzuconych zwierząt.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 md:gap-6">
            <Link
              to="/wplata-jednorazowa"
              className="bg-accessible-red-600 text-white px-8 py-4 rounded-lg btn-text-large hover:bg-accessible-red-700 transition-all duration-300 flex items-center justify-center gap-2 group shadow-lg transform hover:scale-105"
            >
              <Heart className="w-6 h-6 text-white animate-pulse" aria-hidden="true" />
              <span>WPŁAĆ TERAZ</span>
              <ArrowRight className="w-5 h-5 text-white group-hover:translate-x-1 transition-transform" aria-hidden="true" />
            </Link>
            <Link
              to="/adoptuj"
              className="bg-white/10 text-white px-8 py-4 rounded-lg btn-text-large hover:bg-white/20 transition-all duration-300 flex items-center justify-center gap-2 backdrop-blur-sm border border-white/30 transform hover:scale-105"
            >
              <span>Adoptuj zwierzaka </span>
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}